// animation js 

 const reveals = document.querySelectorAll(".reveal");

    function revealOnScroll() {

      const windowHeight = window.innerHeight;

      reveals.forEach((element) => {

        const elementTop = element.getBoundingClientRect().top;

        const revealPoint = 120;

        if (elementTop < windowHeight - revealPoint) {
          element.classList.add("active");
        }

      });
    }

    window.addEventListener("scroll", revealOnScroll);

    window.addEventListener("load", revealOnScroll);


// insta feed animation js

window.addEventListener("load", function () {

  setTimeout(() => {

    const instaFeed = document.querySelector("#insta-feed");

    if (!instaFeed) return;

    function reveal() {

      const top = instaFeed.getBoundingClientRect().top;

      if (top < window.innerHeight - 100) {
        instaFeed.classList.add("show");
      }
    }

    window.addEventListener("scroll", reveal);

    reveal();

  }, 1000);

});
document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener('change', function (event) {
      const input = event.target;

      if (!input.matches('input[type="radio"]')) return;

      const variantSelects = input.closest('variant-selects[data-context="sticky"]');

      if (!variantSelects) return;

      variantSelects
        .querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)
        .forEach((radio) => {
          radio.classList.toggle('is-selected', radio === input);
        });
    });

    (function () {
       function cleanPrice(value) {
         if (!value) return value;
       
         return value
           .replace(/,/g, '')
           .replace(/\.00$/, '');
       }

      function removePriceFormatting() {
        document.querySelectorAll('.filter__price_number').forEach(function (input) {
          
          if (input.value) {
            input.value = cleanPrice(input.value);
          }
      
          if (input.hasAttribute('max')) {
            input.setAttribute('max', cleanPrice(input.getAttribute('max')));
          }
      
          if (input.hasAttribute('data-max')) {
            input.setAttribute('data-max', cleanPrice(input.getAttribute('data-max')));
          }
        });
      }

      removePriceFormatting();
  
      const observer = new MutationObserver(function () {
        removePriceFormatting();
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
  
      document.addEventListener('input', function (e) {
        if (e.target.matches('.filter__price_number')) {
          e.target.value = cleanPrice(e.target.value);
        }
      });
  
      document.addEventListener('change', function (e) {
        if (e.target.matches('.filter__price_number')) {
          e.target.value = cleanPrice(e.target.value);
        }
      });
    })();


    const counters = document.querySelectorAll(".stat-number");

const animateCounter = (counter) => {

    const target = parseInt(counter.dataset.count, 10);
    const originalText = counter.textContent.trim();

    const hasLeadingZero = /^0\d/.test(originalText);
    const suffix = originalText.includes("+") ? "+" : "";

    const duration = 2000;
    const startTime = performance.now();

    const updateCounter = (currentTime) => {

        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        let current = Math.floor(progress * target);

        let displayValue = current.toString();

        if (hasLeadingZero && target < 10) {
            displayValue = displayValue.padStart(2, "0");
        }

        counter.textContent = displayValue + suffix;

        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            let finalValue = target.toString();

            if (hasLeadingZero && target < 10) {
                finalValue = finalValue.padStart(2, "0");
            }

            counter.textContent = finalValue + suffix;
        }
    };

    requestAnimationFrame(updateCounter);
};

    const observer = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                animateCounter(entry.target);

                observer.unobserve(entry.target);
            }

        });

    }, {
        threshold: 0.4
    });

    counters.forEach(counter => {
        observer.observe(counter);
    });

});
const headers = document.querySelectorAll(".accordion-header");

// headers.forEach(header => {
//   header.addEventListener("click", () => {

//     const item = header.parentElement;

//     // close all other accordions
//     document.querySelectorAll(".accordion-item").forEach(el => {
//       if (el !== item) {
//         el.classList.remove("active");
//         el.querySelector(".accordion-content").classList.add("hidden");
//       }
//     });

//     // toggle current accordion
//     const content = item.querySelector(".accordion-content");
//     item.classList.toggle("active");
//     content.classList.toggle("hidden");

//   });
// });
document.querySelectorAll(".accordion-header").forEach(header => {

    header.addEventListener("click", function () {

        const item = this.parentElement;
        const content = item.querySelector(".accordion-content");

        if (item.classList.contains("active")) {

            // Set current height before collapsing
            content.style.maxHeight = content.scrollHeight + "px";

            requestAnimationFrame(() => {
                content.style.maxHeight = "0px";
                content.style.opacity = "0";
            });

            item.classList.remove("active");

        } else {

            item.classList.add("active");

            content.style.opacity = "1";
            content.style.maxHeight = content.scrollHeight + "px";

            content.addEventListener("transitionend", function handler(e) {

                if (e.propertyName === "max-height" && item.classList.contains("active")) {
                    content.style.maxHeight = "none";
                }

                content.removeEventListener("transitionend", handler);

            });

        }

    });

});